import { render, staticRenderFns } from "./TwoVotes.vue?vue&type=template&id=881b4e5c&scoped=true"
import script from "./TwoVotes.vue?vue&type=script&lang=js"
export * from "./TwoVotes.vue?vue&type=script&lang=js"
import style0 from "./TwoVotes.vue?vue&type=style&index=0&id=881b4e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881b4e5c",
  null
  
)

export default component.exports